// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__waJyW","primary":"styles_primary__eLUrD"};
module.exports.__checksum = "135993040524"
